// extracted by mini-css-extract-plugin
export default {"table":"table__N68","header":"header_ioM0"};